import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from 'swiper/modules';
import { settingActions, settingObj } from '../../store/SettingSlice';
import { getImgPath } from '../../store/JSTool';
import { useSelector, useDispatch } from 'react-redux';
import * as JSTool from '../../store/JSTool';
import VideoAlert from './VideoAlert';


export default function HomePosterView() {

    const [swp, setSwp] = React.useState(null);
    const pageNum = [0, 1, 2, 3, 4];
    const [index, setIndex] = React.useState(0);
    const settingData = useSelector(state => state.settingData);

    const dataAry = [
        {
            "imgUrl": getImgPath("game/overlord_poster_0.png"),
            "videoUrl": getImgPath("game/overlord_mv_0.mp4")
        },
        {
            "imgUrl": "https://game-cdn.aplusjapan-game.com/sfd_web/images/vbg.jpg",
            "videoUrl": "https://game-cdn.aplusjapan-game.com/sfd_web/images/video_all.mp4"
        },
        {
            "imgUrl": getImgPath('game/opm_img2.png'),
            "videoUrl": getImgPath('game/opm_video.mp4')
        },
        {
            "imgUrl": getImgPath("poster_0.jpg"),
            "videoUrl": ""
        },
        {
            "imgUrl": getImgPath("poster_4.jpg"),
            "videoUrl": ""
        }
    ];


    function leftTap() {
        if (swp) {
            swp.slidePrev();
        }
    }

    function rightTap() {
        if (swp) {
            swp.slideNext();
        }
    }

    function indexChanged() {
        if (swp) {
            setIndex(swp.realIndex);
        }
    }

    function pageTap(i) {
        console.log(i);
        if (swp) {
            swp.slideToLoop(i);
        }
    }

    return (
        <Stack sx={{
            width: 1,
            height: settingData.isMobile ? 'auto' : '100vh',
            minHeight: settingData.isMobile ? 'auto' : '100vh',
            position: 'relative',
            minWidth: !settingData.isMobile && '1200px',
        }}>

            <Box
                onClick={leftTap}
                component={'img'}
                src={getImgPath('arrow_left2.png')}
                sx={{
                    top: '48%',
                    zIndex: 4,
                    position: 'absolute',
                    height: settingData.isMobile ? '15px' : '33px',
                    mx: settingData.isMobile ? 2 : 10,
                    cursor: 'pointer',
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: !settingData.isMobile && 'scale(1.2)',
                    }
                }} />

            <Swiper style={{
                height: '100%',
                width: '100%'
            }}
                effect={'fade'}
                loop={true}
                slidesPerView={1}
                modules={[Autoplay, EffectFade]}
                centeredSlides={true}
                slideToClickedSlide={true}

                autoplay={{
                    delay: 10000,
                    disableOnInteraction: false,
                }}

                onActiveIndexChange={(sp) => {
                    indexChanged();
                }}

                onSwiper={(swiper) => {
                    setSwp(swiper);
                }}>

                {
                    dataAry.map((data, index) => {
                        return (JSTool.isEmpty(data.videoUrl) ?
                            <SwiperSlide ><PosterItem data={data} /></SwiperSlide> :
                            <SwiperSlide ><PosterVideo data={data} /></SwiperSlide>)
                    })
                }

            </Swiper>

            <Box
                onClick={rightTap}
                component={'img'}
                src={getImgPath('arrow_right2.png')}
                sx={{
                    top: '48%',
                    position: 'absolute',
                    right: 0,
                    zIndex: 4,
                    height: settingData.isMobile ? '15px' : '33px',
                    mx: settingData.isMobile ? 2 : 10,
                    cursor: 'pointer',
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: !settingData.isMobile && 'scale(1.2)',
                    }
                }} />

            <PageItem pageNum={pageNum} currentIndex={index} pageTap={pageTap} />

            <VideoAlert />

        </Stack>
    );
}

function PageItem(props) {
    const settingData = useSelector(state => state.settingData);
    return (
        <Stack sx={{
            position: 'absolute',
            zIndex: 10,
            width: 1,
            bottom: 0,
            height: settingData.isMobile ? '30px' : '60px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
        }}>

            {props.pageNum.map((v, i) => {
                return <Box
                    key={v}
                    onClick={() => {
                        props.pageTap(i);
                    }}
                    sx={{
                        cursor: 'pointer',
                        mx: 1,
                        width: props.currentIndex == i ? '40px' : '20px',
                        height: settingData.isMobile ? '4px' : '8px',
                        borderRadius: settingData.isMobile ? '2px' : '4px',
                        bgcolor: props.currentIndex == i ? '#ffffff' : '#99999999',
                    }} />
            })}
        </Stack>
    )
}

function PosterItem(props) {
    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            width: 1,
            height: 1,
            bgcolor: 'black',
            position: 'relative',
        }}>
            <Box
                component={'img'}
                src={props.data.imgUrl}
                sx={{
                    width: 1,
                    height: 1,
                    objectFit: 'cover',
                    opacity: 0.5
                }} />

            <Stack sx={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                width: 1,
                position: 'absolute',
                height: 1,
            }}>
                <Stack
                    onClick={() => {
                        dispatch(settingActions.showVideoAlert(props.data));
                    }}
                    sx={{
                        width: settingData.isMobile ? 0.7 : 0.75,
                        maxWidth: '1400px',
                        mx: 2,
                        cursor: 'pointer',
                    }}>
                    <ColorTextView index={0} whiteStr='WORLDWIDE' colorStr='PLAY' />
                    <ColorTextView index={1} whiteStr='BOUNDLESS' colorStr='JOY' end={true} />
                </Stack>

                <Box sx={{
                    width: 1,
                    height: '80px',
                    background: 'linear-gradient(#00000000 , #000000 )',
                    position: 'absolute',
                    bottom: 0,
                }} />
            </Stack>
        </Stack>
    );
}

function PosterVideo(props) {
    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            width: 1,
            height: 1,
            bgcolor: 'black',
        }}>
            <Box
                component={'video'}
                autoPlay={true}
                loop={true}
                muted={true}
                playsInline={true}
                disablePictureInPicture={true}
                poster={props.data.imgUrl}
                src={props.data.videoUrl}
                sx={{
                    width: 1,
                    height: 1,
                    objectFit: 'cover',
                    opacity: 0.5
                }} />

            <Stack sx={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                width: 1,
                position: 'absolute',
                height: 1,
            }}>
                <Stack
                    onClick={() => {
                        dispatch(settingActions.showVideoAlert(props.data));
                    }}
                    sx={{
                        width: settingData.isMobile ? 0.7 : 0.75,
                        maxWidth: '1400px',
                        mx: 2,
                        cursor: 'pointer',
                    }}>
                    <ColorTextView index={0} whiteStr='WORLDWIDE' colorStr='PLAY' />
                    <ColorTextView index={1} whiteStr='BOUNDLESS' colorStr='JOY' end={true} />
                </Stack>

                <Box sx={{
                    width: 1,
                    height: '80px',
                    background: 'linear-gradient(#00000000 , #000000 )',
                    position: 'absolute',
                    bottom: 0,
                }} />
            </Stack>
        </Stack>
    );
}

function ColorTextView(props) {
    const settingData = useSelector(state => state.settingData);
    const [showAni, setShowAni] = React.useState(false);

    React.useEffect(() => {
        setTimeout(() => {
            setShowAni(true);
        }, 2500);
    }, [])

    return (
        <Stack sx={{
            opacity: settingObj.showLogoAni ? 0 : 1,
            flexDirection: 'row',
            display: 'flex',
            justifyContent: props.end ? 'flex-end' : 'start',
            animation: ((showAni && settingObj.showLogoAni) && (props.index == 0 ? 'leftAni10 1.5s ease-in-out forwards' : 'rightAni10 1.5s ease-in-out forwards')),
        }}>
            <Typography sx={{
                lineHeight: settingData.isMobile ? '25px' : '100px',
                color: 'white',
                fontFamily: 'Lexend Deca',
                fontSize: settingData.isMobile ? 18 : 85,
            }}>
                {props.whiteStr}
            </Typography>

            <Typography sx={{
                lineHeight: settingData.isMobile ? '25px' : '100px',
                color: '#FFA129',
                fontFamily: 'Lexend Deca',
                fontSize: settingData.isMobile ? 18 : 85,
                ml: settingData.isMobile ? 1 : 5,
            }}>
                {props.colorStr}
            </Typography>
        </Stack>
    );
}

